var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('router-link', {
    attrs: {
      "to": {
        name: 'LiffNewsShow',
        params: {
          id: _vm.news.id
        }
      },
      "custom": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var navigate = _ref.navigate;
        return [_c('div', {
          staticClass: "s-news-item",
          on: {
            "click": navigate
          }
        }, [_c('div', {
          staticClass: "s-news-item-image"
        }, [_c('img', {
          attrs: {
            "src": _vm.news.image_url
          }
        })]), _c('div', {
          staticClass: "s-news-item-info"
        }, [_c('div', {
          staticClass: "s-space-y-2 s-mr-auto"
        }, [_c('p', {
          staticClass: "s-text-gray-darker s-font-semibold"
        }, [_vm._v(_vm._s(_vm.news.title))]), _c('p', {
          staticClass: "s-text-gray s-text-xs s-whitespace-nowrap"
        }, [_vm._v(_vm._s(_vm.datetime))])])])])];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }